import { render, staticRenderFns } from "./CardsWrapper.vue?vue&type=template&id=862d35e4&"
import script from "./CardsWrapper.vue?vue&type=script&lang=js&"
export * from "./CardsWrapper.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports